import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EnableFor } from '../../../../../__legacy__/containers/EnableForRole';
import { useProjectPermissions } from '../../../../../__legacy__/modules/projects/projects.permissions';
import { TRAINING_VARIANT, TRAINING_VARIANTS_LIST } from '../../../../jobs/jobs.model';
import { CreateProjectModalLayout } from './CreateProjectModalLayout';

interface IProps {
  isShown: boolean;
  handleCreateProjectClicked: (template: TRAINING_VARIANT | null) => Promise<void>;
  toggleModal: () => void;
  isLoading: boolean;
}

export const CreateProjectModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const permissions = useProjectPermissions();

  const templates = [
    { label: t('blank_project'), value: null },
    ...TRAINING_VARIANTS_LIST.map((item) => ({ label: t(`training_variants.${item}`), value: item })),
  ];

  const handleClick = (): void => {
    props.toggleModal();
  };

  return (
    <EnableFor hasPermission={permissions.canCreate()}>
      <Button onClick={handleClick}>{t('create_new_project')}</Button>
      <CreateProjectModalLayout
        isOpen={props.isShown}
        toggle={props.toggleModal}
        headerText={t('create_project')}
        buttons={
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.toggleModal}
            loading={props.isLoading}
          >
            {t('cancel')}
          </Button>
        }
      >
        <p>{t('create_project_template_description')}</p>
        <div className='create-project-templates-container'>
          {templates.map((item) => (
            <Button
              className='create-project-template-button'
              variant='outlined'
              loading={props.isLoading}
              onClick={() => {
                void props.handleCreateProjectClicked(item.value);
              }}
              key={item.value}
            >
              {item.label}
            </Button>
          ))}
        </div>
      </CreateProjectModalLayout>
    </EnableFor>
  );
});
